// extracted by mini-css-extract-plugin
module.exports = {"detail":"detail-item--detail--2jP3p5F"};